import React, { useReducer, useContext, useEffect } from "react";
import VtradingContext from "./VTradingContext";
import VtradingReducer from "./VTradingReducer";
import axios from "axios";
import AuthContext from "../auth/authContext";
import isTokenExpired from "../../helpers/jwtHelper";
import dotenv from "dotenv";
import cryptoContext from "../crypto/cryptoContext";
import moment from "moment";
import {
  SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT,
  SET_ACTIVE_CRYPTO_IN_VT,
  PLACE_ORDER_IN_VT,
  PLACE_ORDER_IN_VT_ERROR,
  GET_PARTICULAR_PORTFOLIO_IN_VT,
  SET_SELL_TYPE_IN_VT,
  GET_COINS_IN_PARTICULAR_PORTFOLIO_IN_VT,
  FILTER_PORTID_IN_GET_USER_POSITION_IN_VT,
  SET_ACTIVE_PRICE,
  TOGGLE_VTRADING_ALERT_MODAL,
  SET_SELL_PRICE_FOR_STOP_LIMIT,
  PLACE_SELL_ORDER,
  CANCEL_ORDER_IN_VT,
  MODIFY_ORDER_IN_VT,
  SET_TOTAL_INV_AMOUNT,
  SET_TOTAL_CURRENT_AMOUNT,
  SET_NET_PL,
  CLEAR_VTRADING_ERROR,
  CLEAR_VTRADING_MESSAGE,
  SET_ALREADY_INVESTED,
  START_VTRADING_LOADING,
  STOP_VTRADING_LOADING,
  CLEAR_COINS_DATA,
  SET_QUANTITY,
  CHECK_PAID_PORTFOLIO,
  BUY_NEW_PORTFOLIO,
} from "../types";
import parameterContext from "../parameter/parameterContext";
const getActiveItemForSellFromLocalStorage = localStorage.getItem(
  "activeItemForSell"
)
  ? JSON.parse(localStorage.getItem("activeItemForSell"))
  : null;
const getAlreadyInvestedFromLocalStorage = localStorage.portfolio
  ? JSON.parse(localStorage.portfolio)
  : [];
dotenv.config();
const VtradingState = ({ children }) => {
  const { token, logoutUser, userData, getUser } = useContext(AuthContext);
  const { vtButton, placeOrderType, activePortfolio } =
    useContext(parameterContext);
  const { livePriceData } = useContext(cryptoContext);
  useEffect(() => {
    // let coinPrice=cryptoData?.map((i,index)=>i.symbol===state.activeCrypto.symbol&&cryptoData[index].price)[0]
    //  console.log(coinPrice)
    let coinPrice = livePriceData && livePriceData[state.activeCrypto.symbol];

    //  console.log(coinPrice1[0].price)
    if (placeOrderType === "market") {
      setActiveCrypto({ ...state.activeCrypto, price: coinPrice });
    }
    setActivePrice({ ...state.activePrice, price: coinPrice });

    //eslint-disable-next-line
  }, [livePriceData]);
  const initialState = {
    activeCrypto: getActiveItemForSellFromLocalStorage,
    activePortID: 1,
    orderDetails: null,
    vtradingError: null,
    singlePortfolio: null,
    portId: null,
    orderType: "buy",
    coinsData: null,
    currentPortIDDetails: null,
    activePrice: null,
    vtradingAlertModal: false,
    sellPrice: null,
    invAmount: null,
    currentAmount: null,
    netPL: null,
    vtradingMessage: null,
    PCSTAmount: null,
    alreadyInvested: getAlreadyInvestedFromLocalStorage,
    vTradingLoading: true,
    count: 0,
    position: null,
    historyOrders: null,
    openOrders: null,
  };
  const [state, dispatch] = useReducer(VtradingReducer, initialState);

  const setActiveCrypto = (data) => {
    dispatch({ type: SET_ACTIVE_CRYPTO_IN_VT, payload: data });
  };
  const setActivePortID = (p) => {
    dispatch({ type: SET_ACTIVE_PORTFOLIO_ID_IN_MODAL_IN_VT, payload: p });
  };
  const setSellType = (type) => {
    dispatch({ type: SET_SELL_TYPE_IN_VT, payload: type });
  };
  const placeOrder = async (formData) => {
    clearError();
    clearMessage();
    // dispatch({ type: START_VTRADING_LOADING})
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_VTRADING}/virtualTrading/placeOrder`,
        formData,
        config
      );
      //place order in vt
      dispatch({
        type: PLACE_ORDER_IN_VT,
        payload: data,
        portfolio: activePortfolio,
      });
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    getCoinsInParticularPortfolioInVt();
    // dispatch({ type: STOP_VTRADING_LOADING})
  };
  const placeMarketBuyOrder = async (formData) => {
    clearError();
    clearMessage();
    // dispatch({ type: START_VTRADING_LOADING})
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_VTRADING}/virtualTrading/placeBuyMarketOrder`,
        formData,
        config
      );
      //place order in vt
      dispatch({ type: PLACE_ORDER_IN_VT, payload: data });
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    getCoinsInParticularPortfolioInVt();
    // dispatch({ type: STOP_VTRADING_LOADING})
  };
  const placeMarketSellOrder = async (formData) => {
    clearError();
    clearMessage();
    // dispatch({ type: START_VTRADING_LOADING})
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_VTRADING}/virtualTrading/placesellmarketorder`,
        formData,
        config
      );
      //place order in vt
      dispatch({ type: PLACE_ORDER_IN_VT, payload: data });
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    getCoinsInParticularPortfolioInVt();
    // dispatch({ type: STOP_VTRADING_LOADING})
  };
  const placeStoplimitOrder = async (formData) => {
    // dispatch({ type: START_VTRADING_LOADING})
    clearError();
    clearMessage();
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_VTRADING}/virtualTrading/placestoplimitorder`,
        formData,
        config
      );

      dispatch({ type: PLACE_SELL_ORDER, payload: data });
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    getCoinsInParticularPortfolioInVt();
    // dispatch({ type: STOP_VTRADING_LOADING})
  };

  const getCoinsInParticularPortfolioInVt = async (status = 1) => {
    dispatch({ type: START_VTRADING_LOADING, vtButton });
    clearError();
    clearMessage();
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }
      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      if (status === 1) {
        const url =
          vtButton === "position"
            ? `${process.env.REACT_APP_VTRADING}/virtualTrading/getUserPosition`
            : vtButton === "history"
            ? `${process.env.REACT_APP_VTRADING}/virtualTrading/getPlacedOrderHistory`
            : `${process.env.REACT_APP_VTRADING}/virtualTrading/getOpenOrder`;
        const { data } = await axios.post(
          url,
          vtButton === "openOrder" ? { pid: userData.profile_data._id } : {},
          config
        );
        if (data.data && data.data.length > 0) {
          dispatch({
            type: GET_COINS_IN_PARTICULAR_PORTFOLIO_IN_VT,
            payload: data,
            vtButton,
            activePortfolio,
          });
        }
      } else {
        console.log(status);
        dispatch({ type: CHECK_PAID_PORTFOLIO });
      }

      // console.log(JSON.stringify(data) + " vt");
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    setTimeout(() => {
      dispatch({ type: STOP_VTRADING_LOADING });
    }, 1500);

    filterPortIDInUserPosition();
  };
  const filterPortIDInUserPosition = () => {
    dispatch({ type: FILTER_PORTID_IN_GET_USER_POSITION_IN_VT });
  };
  const setActivePrice = (price) => {
    dispatch({ type: SET_ACTIVE_PRICE, payload: price });
  };
  const toggleVtradingAlertModal = () => {
    dispatch({ type: TOGGLE_VTRADING_ALERT_MODAL });
  };
  const setSellPrice = (price) => {
    dispatch({ type: SET_SELL_PRICE_FOR_STOP_LIMIT, payload: price });
  };
  const cancelOrder = async (orderid) => {
    // dispatch({ type: START_VTRADING_LOADING})
    clearError();
    clearMessage();
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.put(
        `${process.env.REACT_APP_VTRADING}/virtualTrading/cancelOrder`,
        {
          orderid,
        },
        config
      );
      //Cancel order in vt
      dispatch({
        type: CANCEL_ORDER_IN_VT,
        payload: data,
        portfolio: activePortfolio - 1,
      });
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    // getCoinsInParticularPortfolioInVt();
    // dispatch({ type: STOP_VTRADING_LOADING})
  };
  const modifyOrder = async (formData) => {
    // dispatch({ type: START_VTRADING_LOADING})
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_VTRADING}/virtualTrading/modifyOrder`,
        formData,
        config
      );

      //place order in vt

      dispatch({ type: MODIFY_ORDER_IN_VT, payload: data });
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    getCoinsInParticularPortfolioInVt();
    getParticularPortfolio();
    // dispatch({ type: STOP_VTRADING_LOADING})
  };
  const setTotalInvAmount = (data) => {
    dispatch({ type: SET_TOTAL_INV_AMOUNT, payload: data });
  };
  const setTotalCurrentAmount = (data) => {
    dispatch({ type: SET_TOTAL_CURRENT_AMOUNT, payload: data });
  };
  const setTotalNetPL = (data) => {
    dispatch({ type: SET_NET_PL, payload: data });
  };
  const clearMessage = () => {
    dispatch({ type: CLEAR_VTRADING_MESSAGE });
  };
  const clearError = () => {
    dispatch({ type: CLEAR_VTRADING_ERROR });
  };
  const setAlreadyInvested = () => {
    dispatch({
      type: SET_ALREADY_INVESTED,
      payload:
        userData &&
        userData.profile_data &&
        userData.VirtualPortfolio &&
        userData.VirtualPortfolio.map((d, index) =>
          moment(d.updatedAt).isSame(d.createdAt)
        ),
    });
    // console.log(JSON.stringify(data) + " vt");
  };

  const clearCoinsData = () => {
    dispatch({ type: CLEAR_COINS_DATA });
  };

  const setQuantity = (data) => {
    dispatch({ type: SET_QUANTITY, payload: data });
  };

  const buyNewPortfolio = async (portName) => {
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }

      const config = {
        headers: {
          "x-auth-token": token,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_VTRADING}/virtualTrading/buyNewPortfolio`,
        {
          pid: userData.profile_data._id,
          portName: portName,
        },
        config
      );
      getUser();

      //place order in vt
      dispatch({ type: BUY_NEW_PORTFOLIO, payload: data });
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getParticularPortfolio = async () => {
    dispatch({ type: START_VTRADING_LOADING, vtButton });
    clearError();
    clearMessage();
    try {
      if (token && isTokenExpired(token)) {
        logoutUser();
      }
      const config = {
        headers: {
          "x-auth-token": token,
        },
      };

      const url = `${process.env.REACT_APP_VTRADING}/virtualTrading/getUserPosition`;
      const { data } = await axios.post(url, {}, config);

      dispatch({
        type: GET_PARTICULAR_PORTFOLIO_IN_VT,
        payload: data,
        vtButton,
        activePortfolio,
      });

      // console.log(JSON.stringify(data) + " vt");
    } catch (err) {
      dispatch({
        type: PLACE_ORDER_IN_VT_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    setTimeout(() => {
      dispatch({ type: STOP_VTRADING_LOADING });
    }, 1500);
  };
  return (
    <VtradingContext.Provider
      value={{
        getParticularPortfolio,
        setActiveCrypto,
        placeOrder,
        setActivePortID,
        getCoinsInParticularPortfolioInVt,
        filterPortIDInUserPosition,
        setSellType,
        setActivePrice,
        toggleVtradingAlertModal,
        setSellPrice,
        cancelOrder,
        modifyOrder,
        placeStoplimitOrder,
        PCSTAmount: state.PCSTAmount,
        activeCrypto: state.activeCrypto,
        orderDetails: state.orderDetails,
        vtradingError: state.vtradingError,
        vtradingMessage: state.vtradingMessage,
        orderType: state.orderType,
        singlePortfolio: state.singlePortfolio,
        activePortID: state.activePortID,
        portId: state.portId,
        coinsData: state.coinsData,
        currentPortIDDetails: state.currentPortIDDetails,
        activePrice: state.activePrice,
        vtradingAlertModal: state.vtradingAlertModal,
        sellPrice: state.sellPrice,
        setTotalInvAmount,
        setTotalCurrentAmount,
        invAmount: state.invAmount,
        currentAmount: state.currentAmount,
        setTotalNetPL,
        netPL: state.netPL,
        clearError,
        clearMessage,
        setAlreadyInvested,
        alreadyInvested: state.alreadyInvested,
        vTradingLoading: state.vTradingLoading,
        count: state.count,
        placeMarketBuyOrder,
        placeMarketSellOrder,
        quantity: state.quantity,
        setQuantity,
        clearCoinsData,
        position: state.position,
        historyOrders: state.historyOrders,
        openOrders: state.openOrders,

        buyNewPortfolio,
      }}
    >
      {children}
    </VtradingContext.Provider>
  );
};

export default VtradingState;
